import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { ImportData } from '@wix/extensions-data-client';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import {
  BackOfficeHostingPlatforms,
  ComponentType,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { getExtensionPath } from '@wix/cli-astro-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-plugin'
);

export async function generateDashboardPlugin(
  projectFolder: string,
  extended: string,
  folder: string,
  title: string,
  importData?: ImportData
) {
  const component: Component = {
    compId: randomUUID(),
    compType: ComponentType.BACK_OFFICE_EXTENSION_WIDGET,
    compName: title,
    compData: {
      backOfficeExtensionWidget: {
        hostingPlatform: BackOfficeHostingPlatforms.BUSINESS_MANAGER,
        extends: extended,
        title,
      },
    },
  };

  const cwd = getExtensionPath(projectFolder, folder);
  const pluginConfigJSON = toJsonString(component, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      pluginConfigJSON,
      importData,
    },
    importData,
  });
}
